import { render, staticRenderFns } from "./IPDDashboard.vue?vue&type=template&id=c0807414&"
import script from "./IPDDashboard.vue?vue&type=script&lang=js&"
export * from "./IPDDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports